import { render, staticRenderFns } from "./AppRating.vue?vue&type=template&id=41c07a7a"
import script from "./AppRating.vue?vue&type=script&lang=js"
export * from "./AppRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports